import { api } from "api/api";
import { AxiosError } from "axios";
import Produto from "model/administracao/cadastro/produto/Produto";
import Deposito from "model/suprimentos/Deposito";
import EstoqueLote from "model/suprimentos/EstoqueLote";
import Transacao from "model/suprimentos/Transacao";
import TransferenciaEstoque from "model/suprimentos/TransferenciaEstoque";


class TransfereniciaEstoqueService {

    transferir(transferenciaEstoque: TransferenciaEstoque) {
        return new Promise<void>((resolve, reject): void => {
            api
                .post(`/transferenciaEstoque/transferir`, JSON.stringify(transferenciaEstoque))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });

    }

    getDepositos() {
        return new Promise<Array<Deposito>>((resolve, reject): void => {
            api
                .get(`/transferenciaEstoque/depositos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTransacoesEntrada() {
        return new Promise<Array<Transacao>>((resolve, reject): void => {
            api
                .get(`/transferenciaEstoque/transacoes/ENTRADA`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTransacoesSaida() {
        return new Promise<Array<Transacao>>((resolve, reject): void => {
            api
                .get(`/transferenciaEstoque/transacoes/SAIDA`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getProdutosDisponiveis(deposito: Deposito) {
        return new Promise<Array<Produto>>((resolve, reject): void => {
            api
                .get(`/transferenciaEstoque/produtosDisponiveis/${deposito.codigo}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getLotesDisponiveis(deposito: Deposito, produto: Produto) {
        return new Promise<Array<EstoqueLote>>((resolve, reject): void => {
            api
                .get(`/transferenciaEstoque/lotesDisponiveis/${deposito.codigo}/${produto.codigo}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getValorUnitario(lote: EstoqueLote) {
        return new Promise<number>((resolve, reject): void => {
            api
                .get(`/transferenciaEstoque/valorUnitario/${encodeURIComponent(lote.produto.codigo as string)}/${encodeURIComponent(lote.lote as string)}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTransacaoPadraoSaida() : Promise<Transacao> {
        return this.getTransacaoPadrao("SAIDA")
    }
    getTransacaoPadraoEntrada() : Promise<Transacao> {
        return this.getTransacaoPadrao("ENTRADA")
    }

    getTransacaoPadrao(tipo: string): Promise<Transacao> {
        return new Promise<Transacao>((resolve, reject): void => {
            api
                .get(`/transferenciaEstoque/transacaoPadrao/${tipo}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default TransfereniciaEstoqueService;